import { TFunction } from 'i18next';
import { UseFormGetValues, ValidationRule } from 'react-hook-form';

import { isValid } from './validDriversLicense';

const vinValidator = require('vin-validator');

class ValidationUtils {
  public zipCodeValidation(): ValidationRule<RegExp> {
    return {
      value: /^\d{5}(?:[-\s]?\d{4})?$/,
      message: 'Zip code is invalid.',
    };
  }

  public emailValidation(): ValidationRule<RegExp> {
    return {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: 'Email is invalid.',
    };
  }

  public firstnameValidation(): ValidationRule<any> {
    return {
      value: /^[A-Za-z0-9]*((\s[A-Za-z0-9]*)*)$/,
      message: 'First name is invalid.',
    };
  }

  public lastnameValidation(): ValidationRule<any> {
    return {
      value: /^[A-Za-z0-9]*((\s[A-Za-z0-9]*)*)$/,
      message: 'Last name is invalid.',
    };
  }

  public usernameValidation(): ValidationRule<any> {
    return {
      value: /^[a-zA-Z0-9.\-_$@*!]{3,30}$/,
      message: 'Username is invalid.',
    };
  }

  public extNumberValidation(): ValidationRule<any> {
    return {
      value: /^(0|[1-9]\d*)$/,
      message: 'Invalid number.',
    };
  }

  public rangeValidation(
    min: number,
    max: number,
    t: TFunction,
  ): ValidationRule<any> {
    return {
      validate: (value: number) =>
        (value >= min && value <= max) || t('common.range', { min, max }),
    };
  }

  public validDateFormat(): string {
    return 'yyyy-MM-dd';
  }

  public vinValidation(t: TFunction): ValidationRule<any> {
    return {
      validate: (value: number) => {
        return vinValidator.validate(value) || t('common.invalidVIN');
      },
    };
  }

  public accountNumberValidation(
    t: TFunction,
    key: string,
  ): ValidationRule<RegExp> {
    return {
      value: /^[0-9]*$/,
      message: t(key),
    };
  }

  public driversLicenseValidation(
    stateCode: string,
    t: TFunction,
  ): ValidationRule<any> {
    return {
      validate: (value: string) =>
        isValid(stateCode, value) || t('driver.invalidDriversLicense'),
    };
  }

  public validatePassword(t: TFunction): ValidationRule<any> {
    return {
      validate: (password: string) => {
        const test =
          /[a-z]/g.test(password) &&
          /[A-Z]/g.test(password) &&
          /\d/g.test(password) &&
          password?.length > 7;
        return (
          (/[a-z]/g.test(password) &&
            /[A-Z]/g.test(password) &&
            /\d/g.test(password) &&
            password?.length > 7) ||
          t('onboard.invalidPassword')
        );
      },
    };
  }

  public validatePasswordMatch(
    getValues: UseFormGetValues<any>,
    t: TFunction,
  ): ValidationRule<any> {
    return {
      validate: () => {
        const values = getValues();
        return (
          values.Password === values.ConfirmPassword ||
          t('onboard.passwordMismatch')
        );
      },
    };
  }
}

const validationUtils = new ValidationUtils();

export default validationUtils;
